// extracted by mini-css-extract-plugin
module.exports = {"audioBtn":"Player_audioBtn__3WED9"};